import { useEffect, useState } from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';

import { publicDataDomain } from '../../../util/config';

interface UseFetchPlaylistDataProps {
	playlistId: string;
	accountId: string;
}
const useFetchPlaylistData = ({ playlistId, accountId }: UseFetchPlaylistDataProps) => {
	const dispatch = useDispatch();
	const [playlistData, setPlaylistData] = useState<any>();

	useEffect(() => {
		if (!playlistId || !accountId) {
			return;
		}

		const url = publicDataDomain + accountId + '/playlists/' + playlistId;
		axios.get(url).then((response) => {
			if ((response?.data.medias ?? []).length > 0) {
				response?.data.medias.sort((itemA: any, itemB: any) => {
					return itemA.order - itemB.order;
				});
			}
			setPlaylistData(response?.data);
		});
	}, [playlistId, accountId, dispatch]);

	return playlistData;
};

export default useFetchPlaylistData;
